/**
 * The keyboard shortcuts, listed. Opened with "?" or from the account menu.
 */
import { useTranslation } from 'react-i18next';
import { Modal } from '../components/Modal.jsx';
import { MOD_KEY } from './Topbar.jsx';

/** Labels are keys in navigation:shortcuts.*, looked up when rendered. */
const SHORTCUTS = [
  { keys: [MOD_KEY, 'K'], label: 'commandCenterSearch' },
  { keys: ['/'], label: 'commandCenter' },
  { keys: ['['], label: 'toggleNav' },
  { keys: ['?'], label: 'showShortcuts' },
  { keys: ['↑', '↓'], label: 'moveResults' },
  { keys: ['Enter'], label: 'openResult' },
  { keys: ['Esc'], label: 'close' },
];

export function ShortcutsDialog({ open, onClose }) {
  const { t } = useTranslation('navigation');
  return (
    <Modal open={open} onClose={onClose} title={t('shortcuts.title')} description={t('shortcuts.description')}>
      <dl className="shortcuts">
        {SHORTCUTS.map((shortcut) => (
          <div key={shortcut.label} className="shortcuts-row">
            <dt className="shortcuts-keys">
              {shortcut.keys.map((key) => (
                <kbd key={key}>{key}</kbd>
              ))}
            </dt>
            <dd>{t(`shortcuts.keys.${shortcut.label}`)}</dd>
          </div>
        ))}
      </dl>
    </Modal>
  );
}
